const blogType = {
    SETBLOG: 'SETBLOG',
    CREATE_BLOG: 'CREATE_BLOG',
    DELETE_BLOG: 'DELETE_BLOG',
};

export default blogType;